import { isProductsCategory, isRecipesCategory } from '../config/category-constants';

/**
 * Constantes pour les valeurs de visibilité
 */
export const VISIBILITY_VALUES = {
    PUBLIC: 'PUBLIC',
    PUBLIC_FR: 'PUBLIQUE',
    PUBLIC_NL: 'OPENBAAR',
    PRIVATE: 'PRIVATE',
    PRIVATE_FR: 'PRIVÉ',
    PRIVATE_NL: 'PRIVÉ'
} as const;

/**
 * Check if the user has access to a specific product or recipe.
 * @param productRootCategory - The root category of the product.
 * @param isAuthenticated - Indicates if the user is authenticated.
 * @param wbsCulinaryDisplay - The display setting for WBS Culinary.
 * @returns True if the user has access, false otherwise.
 */
export const checkIsAccessible = (
    productRootCategory: string | undefined,
    isAuthenticated: boolean,
    wbsCulinaryDisplay: string | undefined
): boolean => {
    // console.log('✅ Product root category:', productRootCategory);
    // console.log('✅ Is authenticated:', isAuthenticated);
    // console.log('✅ WBS Culinary Display:', wbsCulinaryDisplay);

    // Pour les produits : accès seulement si authentifié
    if (isProductsCategory(productRootCategory) || !productRootCategory || productRootCategory.trim() === '') {
        return isAuthenticated;
    }

    // Pour les recettes : dépend du flag de visibilité
    if (isRecipesCategory(productRootCategory)) {
        // Si PUBLIC, accès libre ; si PRIVATE, accès seulement si authentifié (si pas de flag de visibilité, considérer comme PRIVATE)
        const culinaryDisplay = wbsCulinaryDisplay?.toUpperCase() ?? VISIBILITY_VALUES.PRIVATE;
        return (
            culinaryDisplay === VISIBILITY_VALUES.PUBLIC ||
            culinaryDisplay === VISIBILITY_VALUES.PUBLIC_FR ||
            culinaryDisplay === VISIBILITY_VALUES.PUBLIC_NL ||
            isAuthenticated
        );
    }

    // console.log('❌ Access denied for product/recipe:', productRootCategory);
    return false;
};

/**
 * Détermine si un produit est visible pour un client spécifique (catalogue spécifique)
 * @param wbsCustomerSpecific - Valeur de l'attribut WBS_CUST_HIERARCHY_SPECIFIC (string ou undefined)
 * @param businessPartnerId - Identifiant du client (string ou undefined)
 * @returns True si le produit est visible pour ce client, false sinon.
 */
export const isProductVisibleForCustomer = (wbsCustomerSpecific: string | undefined, businessPartnerId: string | undefined): boolean => {
    const isNotCustomerSpecific = !wbsCustomerSpecific || wbsCustomerSpecific.trim() === '';

    const isCustomerSpecificMatch =
        !!businessPartnerId &&
        businessPartnerId.trim() !== '' &&
        !!wbsCustomerSpecific &&
        wbsCustomerSpecific
            .split(',')
            .map(val => val.trim())
            .includes(businessPartnerId);

    return isNotCustomerSpecific || isCustomerSpecificMatch;
};
